// 8자리 숫자 string 을 0000.00.00 형식으로 변환
export const formatStringDate = (date, separator = '.') => {
  if (date) {
    return `${date}`.replace(/(\d{4})(\d{2})(\d{2})/g, `$1${separator}$2${separator}$3`)
  } else {
    return ''
  }
}

// 문자 string 을 0000.00.00 형식으로 변환
export const formatStringDate2 = (date, separator = '.') => {
  if (date) {
    let temp = date.replace(/-/gi, '').substring(0, 8)
    return temp.replace(/(\d{4})(\d{2})(\d{2})/g, `$1${separator}$2${separator}$3`)
  } else {
    return ''
  }
}

export const formatStringToDotDate = (str) => {
  if (str) {
    let temp = str.replace(/[^0-9]/g, '').substring(0, 8)
    return temp.replace(/(\d{4})(\d{2})(\d{2})/g, `$1.$2.$3`)
  } else {
    return ''
  }
}

export const formatDotDateToString = (date) => {
  if (date) {
    return date.replace(/[^0-9]/g, '').substring(0, 8)
  } else {
    return ''
  }
}

//숫자 콤마처리
export const formatNumberComma = (val) => {
  try {
    if (val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
      return 0
    }
  } catch {
    return 0
  }
}

export const formatNumberCommaDecimal = (val) => {
  try {
    if (val === null || val === undefined || val === '') return ''

    const num = Number(val)
    if (isNaN(num)) return 0

    // 정수부와 소수부 분리
    const [integerPart, decimalPart] = String(num).split('.')

    // 정수부는 천 단위 콤마 추가
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    // 소수부가 있는 경우, 의미 있는(0이 아닌) 자리만 유지
    if (decimalPart && Number(decimalPart) !== 0) {
      // 끝의 불필요한 0 제거
      const trimmedDecimal = decimalPart.replace(/0+$/, '')
      return `${formattedInt}.${trimmedDecimal}`
    }

    // 소수부가 없거나 0인 경우
    return formattedInt
  } catch {
    return ''
  }
}

export const inputNumberDecimal = (val) => {
  try {
    if (val === null || val === undefined || val === '') return ''

    // 문자열로 변환
    const strVal = String(val)

    // 사용자가 "."만 입력했을 경우 그대로 반환
    if (strVal === '.') return ''

    // 숫자와 소수점 외의 문자는 제거
    let cleaned = strVal.replace(/[^0-9.]/g, '')

    // 소수점이 여러 개일 경우 → 첫 번째만 남기고 나머지 제거
    const firstDotIndex = cleaned.indexOf('.')
    if (firstDotIndex !== -1) {
      cleaned = cleaned.slice(0, firstDotIndex + 1) + cleaned.slice(firstDotIndex + 1).replace(/\./g, '') // 이후 소수점은 전부 제거
    }

    // 소수점으로 끝나는 경우 (예: "123.")
    const endsWithDot = cleaned.endsWith('.')

    // 정수부와 소수부 분리
    const [integerPart, decimalPart = ''] = cleaned.split('.')

    // 정수 4자리 제한
    const newInteger = integerPart.slice(0, 4)

    // 소수 2자리 제한 (decimalPart가 존재할 때만)
    const newDecimal = decimalPart !== '' ? decimalPart.slice(0, 2) : ''

    // 소수점이 존재하는 경우
    if (cleaned.includes('.')) {
      const result = `${newInteger}.${newDecimal}`
      // 마지막에 '.'으로 끝났다면 그대로 유지
      return endsWithDot ? `${newInteger}.` : result
    }

    // 소수점이 없는 경우
    return newInteger
  } catch {
    return ''
  }
}

export const inputReadNumberDecimal = (val) => {
  try {
    if (val === null || val === undefined || val === '') return ''

    // 문자열로 변환
    const strVal = String(val)

    // 숫자와 소수점 외의 문자는 제거
    let cleaned = strVal.replace(/[^0-9.\-]/g, '')

    // 소수점이 여러 개일 경우 → 첫 번째만 남기고 나머지 제거
    const firstDotIndex = cleaned.indexOf('.')
    if (firstDotIndex !== -1) {
      cleaned = cleaned.slice(0, firstDotIndex + 1) + cleaned.slice(firstDotIndex + 1).replace(/\./g, '')
    }

    // 정수부와 소수부 분리
    let [integerPart, decimalPart = ''] = cleaned.split('.')

    // 정수부 4자리 제한
    const newInteger = integerPart.slice(0, 4)

    // 소수부 2자리 제한
    let newDecimal = decimalPart?.slice(0, 2)

    // 끝의 0 제거
    newDecimal = newDecimal?.replace(/0+$/, '')

    // 소수부가 전부 제거되었으면 그냥 정수 반환
    if (!newDecimal) return newInteger

    // 그렇지 않으면 소수점 포함 반환
    return `${newInteger}.${newDecimal}`
  } catch {
    return ''
  }
}

//파일용량
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

// 8자리 숫자 string 을 newDate 형식으로 변환
//
export const convertStringToDate = (date) => {
  if (date) {
    // 연, 월, 일을 추출합니다.
    const year = date.substring(0, 4)
    const month = date.substring(4, 6) - 1 // JavaScript에서 월은 0부터 시작하므로 1을 빼줍니다.
    const day = date.substring(6, 8)

    // 새로운 Date 객체 생성하여 반환
    return new Date(year, month, day)
  } else {
    return ''
  }
}
